import React from "react";
import "../styles/header.scss";
import { CiPause1, CiPlay1 } from "react-icons/ci";

const Header = ({pauseSlide, isPauseAudio, showBtn}) => {
  return (
    <div className="header_main">
      <div className="container">
        <div className="flex_container">
          <div className="leftbar">
            <img src="./logo_mobile.png" alt="header logo" />
            <h1>
              <span>Arcaptor</span>
              <span>Technologies</span>
            </h1>
          </div>
          <div className="rightBar">
            {
              showBtn && <button onClick={() => pauseSlide()} title={isPauseAudio ? "Play Slide" : "Pause Slide"}>
              {isPauseAudio ? <><CiPlay1 /> Play</> : <><CiPause1 /> Pause</>}
            </button>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
